import { render } from "./Inicio.vue?vue&type=template&id=6c6670fc"
import script from "./Inicio.vue?vue&type=script&lang=js"
export * from "./Inicio.vue?vue&type=script&lang=js"

import "./Inicio.vue?vue&type=style&index=0&id=6c6670fc&lang=css"

import exportComponent from "C:\\Users\\Fernando\\Desktop\\curso Innovaccion Virtual\\FrontEnd\\Practica5 VUE\\pasteleria-vuex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__